import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#FFC423",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          display: "block",
        },
      },
    },
    MuiTextField: {
      variants: [
        {
          props: { error: true },
          style: { input: { background: red[50] } },
        },
      ],
      defaultProps: {
        autoComplete: "off",
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "body2" },
          style: { color: "#838BA1", fontSize: 16, lineHeight: 1.5 },
        },
      ],
    },
  },
});

export default theme;
